import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useTranslation } from 'react-i18next'
import Content from '../Content'

export default function ChatMessage({
  event,
  className,
  clamp
}: {
  event: Event
  className?: string
  clamp?: boolean
}) {
  const { t } = useTranslation()

  return (
    <div className={cn('space-y-2', className)}>
      <div className="text-sm text-muted-foreground font-medium">
        {t('Chat message — shown without context')}
      </div>
      <Content event={event} clamp={clamp} />
    </div>
  )
}
